module.exports = __webpack_public_path__ + "img/ai-chat-active-icon.9ad34459.svg";